/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: feedback.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  DeleteFeedbackRequest,
  DeleteFeedbackResponse,
  GetFeedbackRequest,
  GetFeedbackResponse,
  ListFeedbackRequest,
  ListFeedbackResponse,
  SubmitFeedbackRequest,
  SubmitFeedbackResponse,
  UpdateFeedbackRequest,
  UpdateFeedbackResponse,
} from '../types/feedback';

export const createFeedbackService = (transport: Transport) => ({
  async submitFeedback(
    request: SubmitFeedbackRequest,
    options: RequestOptions = {},
  ): Promise<SubmitFeedbackResponse> {
    const { organization_id, ...body } = request;
    const url = getApiPath(API_METHODS.FeedbackService.SubmitFeedback, { organization_id });
    return transport.post<SubmitFeedbackResponse>(url, body, options);
  },

  async getFeedback(
    request: GetFeedbackRequest,
    options: RequestOptions = {},
  ): Promise<GetFeedbackResponse> {
    const { organization_id, feedback_id } = request;
    const url = getApiPath(API_METHODS.FeedbackService.GetFeedback, {
      organization_id,
      feedback_id,
    });
    return transport.get<GetFeedbackResponse>(url, options);
  },

  async listFeedback(
    request: ListFeedbackRequest,
    options: RequestOptions = {},
  ): Promise<ListFeedbackResponse> {
    const { organization_id, ...params } = request;
    const url = getApiPath(API_METHODS.FeedbackService.ListFeedback, { organization_id });
    return transport.get<ListFeedbackResponse>(url, { params, ...options });
  },

  async updateFeedback(
    request: UpdateFeedbackRequest,
    options: RequestOptions = {},
  ): Promise<UpdateFeedbackResponse> {
    const { organization_id, feedback_id, ...body } = request;
    const url = getApiPath(API_METHODS.FeedbackService.UpdateFeedback, {
      organization_id,
      feedback_id,
    });
    return transport.post<UpdateFeedbackResponse>(url, body, options);
  },

  async deleteFeedback(
    request: DeleteFeedbackRequest,
    options: RequestOptions = {},
  ): Promise<DeleteFeedbackResponse> {
    const { organization_id, feedback_id } = request;
    const url = getApiPath(API_METHODS.FeedbackService.DeleteFeedback, {
      organization_id,
      feedback_id,
    });
    return transport.delete<DeleteFeedbackResponse>(url, options);
  },
});

export type FeedbackService = ReturnType<typeof createFeedbackService>;
